export { default } from './MainHeader'


// WEBPACK FOOTER //
// ./src/components/Header/MainHeader/index.js